import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

export default function CardBadge({ className, children }) {
  return (
    <div
      className={classnames(
        'CardBadge inline-flex items-center justify-between br-pill no-select font-12 white pt1 pb1 pl2 pr2',
        className
      )}
      style={{ backgroundColor: '#040415A3' }}
      data-test-id="CardBadge"
    >
      <span>{children}</span>
    </div>
  );
}

CardBadge.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired
};

CardBadge.defaultProps = {
  className: null
};
